window.$ = window.jQuery;
$(document).ready(function () {
    $('footer h6').each(function (index, item) {
        var $el = $(this);

        if (true == $($el).next().is('ul')) {
            $el.addClass('js-footer-header');
        }
    });

    $('footer h6').on('click', function () {
        $(this).next().toggle();
    });

    $('.js-show-mobile-menu').on('click', function () {
        $('#myNav').css("width","100%");
        $("body").css("overflow", "hidden");
    });

    $('.closebtn').on('click', function () {
        $('#myNav').css("width","0%");
        $("body").css("overflow", "visible");
    });

    $('.js-show-mobile-menu-more').on('click', function () {
        const isActive = $('.main-menu__sub-menu').hasClass('js-menu-active');
        if (isActive) {
            $('.main-menu__sub-menu').removeClass('js-menu-active');
            $('.main-menu__sub-menu').slideUp();
        } else {
            $('.main-menu__sub-menu').addClass('js-menu-active');
            $('.main-menu__sub-menu').slideDown();
        }
    });

    $('.js-show-mobile-menu-tours').on('click', function () {
        const isActive = $('.main-menu__sub-menu-tours').hasClass('js-menu-active');
        if (isActive) {
            $('.main-menu__sub-menu-tours').removeClass('js-menu-active');
            $('.main-menu__sub-menu-tours').slideUp();
        } else {
            $('.main-menu__sub-menu-tours').addClass('js-menu-active');
            $('.main-menu__sub-menu-tours').slideDown();
        }
    });

    $('.js-show-mobile-menu-transfers').on('click', function () {
        const isActive = $('.main-menu__sub-menu-transfers').hasClass('js-menu-active');
        if (isActive) {
            $('.main-menu__sub-menu-transfers').removeClass('js-menu-active');
            $('.main-menu__sub-menu-transfers').slideUp();
        } else {
            $('.main-menu__sub-menu-transfers').addClass('js-menu-active');
            $('.main-menu__sub-menu-transfers').slideDown();
        }
    });

    $('.mobile__menu-item').on('click', function () {
        $('.mobile__help-menu-container').slideUp();
    });


    $('.mobile-header__language-btn').on('click', function () {
        $('.mobile-languages ul.languages').toggle();
    });

    $('.js-contact-scroll-down').click(function () {
        $('html, body').animate({
            scrollTop: $(".page-section-content").offset().top - 50
        }, 1000);
        return false;
    });

    $.each($('textarea'), function () {
        var offset = this.offsetHeight - this.clientHeight;

        var resizeTextarea = function (el) {
            $(el).css('height', 'auto').css('height', el.scrollHeight + offset + 50);
        };
        $(this).on('keyup input', function () {
            resizeTextarea(this);
        });
    });

    $('.js-qb-show').on('click', function () {
        $('.quick-booking-mobile').show();
        $('.js-qb-show').hide();
        $('.js-qb-hide').css('display', 'block').show();
        $('.mobile__help-desk-menu').hide();
        return false;
    });

    $('.js-qb-hide').on('click', function () {
        $('.quick-booking-mobile').hide();
        $('.js-qb-show').show();
        $('.js-qb-hide').hide();
        $('.mobile__help-desk-menu').show();
        return false;
    });

    $('.contact__item').on('click', function () {
        return $(window).width() < 1000;
    })

    /**
     * Expands and roll up of div
     */
    $('h4[content_id]').on('click', function(e) {
        $('#'+$(this).attr('content_id')).toggle();
        if($(this).find("i").hasClass('fa-angle-double-down')){
            $(this).find("i").removeClass('fa-angle-double-down');
            $(this).find("i").addClass('fa-angle-double-up');
        }else {
            $(this).find("i").removeClass('fa-angle-double-up');
            $(this).find("i").addClass('fa-angle-double-down');
        }
    });

    let libsLoaded = false;
    window.dataLayer = window.dataLayer || [];
    loadGoogleTags();
    $("body,html").one("touchstart touchmove scroll mousemove mousedown DOMMouseScroll mousewheel keyup", function(e){
        if(libsLoaded){
            return true;
        }

        $(".first-slider-image").hide();
        $(".revslidercolumn").show();
        $(".revslidercolumn").css("height", "auto");

        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.7";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=false;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '487915688349748');
        fbq('track', 'PageView');

        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.async = false;
            js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat' +
                '.js#xfbml=1&alignment=’left’&version=v2.12&autoLogAppEvents=1&greeting_dialog_display=’show’';
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

        libsLoaded = true;

        let lazyLoadCompleteEvent = new Event('lazyLoadCompleteLoaded');
        document.dispatchEvent(lazyLoadCompleteEvent);
    });

    function loadGoogleTags(){
        window.dataLayer = window.dataLayer || [];
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=false;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-MPMF5FK');
    }
});